import script from "./WerkwijzePage.vue?vue&type=script&setup=true&lang=js"
export * from "./WerkwijzePage.vue?vue&type=script&setup=true&lang=js"

import "./WerkwijzePage.vue?vue&type=style&index=0&id=742b8520&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-742b8520"]])

export default __exports__